import { getValuableVariables } from '@anytag/shared-utils';
import {
  useInfluencerProfileEstimatedAudienceQuery,
  useYoutubeAnalyticsAudienceQuery,
  YoutubeAnalyticsAudienceRegionPayload,
  SocialAccountType
} from '@anytag/graphql';
import { useQueryHelper } from '@anytag/shared-hooks';
import { AnalyticsSelectedAccountInfo } from '../../../types';
import { useAnalyticsProfileSearch } from '../../../hooks';
import { AnalyticsYoutubeDashboardAudienceTemplate } from './AnalyticsYoutubeDashboardAudienceTemplate';

export interface AnalyticsYoutubeDashboardAudienceProps {
  analyticsAccount: AnalyticsSelectedAccountInfo;
}

export const AnalyticsYoutubeDashboardAudience = ({ analyticsAccount }: AnalyticsYoutubeDashboardAudienceProps) => {
  const { t, navigate, enqueueSnackbar } = useQueryHelper();
  const { filter } = useAnalyticsProfileSearch();
  const { data, loading } = useYoutubeAnalyticsAudienceQuery({
    fetchPolicy: 'no-cache',
    variables: getValuableVariables({
      endDate: filter.endDate,
      startDate: filter.startDate,
      youtubeAnalyticsAccountId: analyticsAccount.id
    }),
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
      navigate({ to: '/analytics' });
    }
  });
  const { data: estimatedData, loading: estimatedLoading } = useInfluencerProfileEstimatedAudienceQuery({
    variables: {
      socialAccountId: analyticsAccount.id,
      socialAccountType: SocialAccountType.YOUTUBE
    }
  });

  return (
    <AnalyticsYoutubeDashboardAudienceTemplate
      loading={loading || estimatedLoading}
      accountAvatar={analyticsAccount.avatar}
      data={{
        // Mixed data details: https://anymindgroup.atlassian.net/browse/AT-7636
        ...data?.youtubeAnalyticsAudience,
        regionRate:
          estimatedData?.influencerProfileEstimatedAudience?.location?.regions?.map<YoutubeAnalyticsAudienceRegionPayload>(
            ({ regionName, rate }) => ({ rate, name: regionName })
          )
      }}
    />
  );
};
